import { useEffect, useState } from "react";

// Utility function to manage localStorage with expiration
export const useLocalStorageWithExpiry = (key, defaultValue, expiryTime) => {
    const [value, setValue] = useState(() => {
      const storedValue = localStorage.getItem(key);
      if (storedValue) {
        const parsed = JSON.parse(storedValue);
        if (new Date().getTime() < parsed.expiry) {
          return parsed.value;
        } else {
          localStorage.removeItem(key);
        }
      }
      return defaultValue;
    });
  
    useEffect(() => {
      if (value) {
        const expiry = new Date().getTime() + expiryTime;
        localStorage.setItem(key, JSON.stringify({ value, expiry }));
      }
    }, [key, value, expiryTime]);
  
    return [value, setValue];
  };